import { defineComponent as _defineComponent } from 'vue';
import { BButton, BCard, BCollapse, BNav, BNavItem } from "bootstrap-vue";
import { onMounted, onUpdated, ref } from "vue";
import { getCitations } from "@/components/Citation/services";
import { useConfig } from "@/composables/config";
import {} from ".";
import CitationItem from "@/components/Citation/CitationItem.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CitationsList',
    props: {
        id: null,
        source: null,
        simple: { type: Boolean, default: false }
    },
    emits: ["rendered", "show", "shown", "hide", "hidden"],
    setup(__props, { emit }) {
        const props = __props;
        const outputFormats = Object.freeze({
            CITATION: "bibliography",
            BIBTEX: "bibtex",
            RAW: "raw",
        });
        const { config } = useConfig(true);
        const outputFormat = ref(outputFormats.CITATION);
        const citations = ref([]);
        onUpdated(() => {
            emit("rendered");
        });
        onMounted(async () => {
            try {
                citations.value = await getCitations(props.source, props.id);
            }
            catch (e) {
                console.error(e);
            }
        });
        return { __sfc: true, outputFormats, props, config, emit, outputFormat, citations, BButton, BCard, BCollapse, BNav, BNavItem, CitationItem };
    }
});
